import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Snackbar,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import Appbar from "../../components/Appbar";
// import DrawerUI from '../../components/Drawer'
import Body from "../../layout/Body";
import { useStyles } from "../../theme/theme";

import {
  createSearchParams,
  Link as LinkRRD,
  useNavigate,
} from "react-router-dom";

import moment from "moment";
import { singlePublisherUserAction } from "../../redux/toolkit/publisher/parternUsers";
import { useLocation } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { dateFormatStartFun } from "../../helper/dateConverter";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/partner"
      >
        Publiser
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      Publisher User Data
    </Typography>
  </Stack>
);

const PublisherUserInfo = () => {
  const publisherId = useLocation()?.search?.split("?")[1];
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  let dispatch = useDispatch();
  const classes = useStyles();
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  const { data, loading, status, total } = useSelector(
    (state) => state.singlePublisherUsers
  );

  const adminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      maxWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
      renderCell: (params) => {
        return (
          <LinkRRD to={`/user-detail?${params?.row?._id}`}>
            <Typography color="primary">{params?.row?._id}</Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "email",
      headerName: "Email",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 300,
    },

    {
      field: "reward",
      headerName: "Reward",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {params?.row?.reward.toFixed(4)}
          </Typography>
        );
      },
    },

    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 250,
      renderCell: (params) => {
        return (
          // <Typography>{params?.row?.created_at}</Typography>
          moment(params?.row?.created_at).local().format("DD-MM-YYYY,h:mm:ss a")
        );
      },
    },
  ];

  const dateWiseUser = () => {
    dispatch(
      singlePublisherUserAction({
        publisherId: publisherId,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        page: pageState?.page,
        pageSize: pageState?.pageSize,
      })
    );
  };

  useEffect(() => {
    dispatch(
      singlePublisherUserAction({
        publisherId: publisherId,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        page: pageState.page,
        pageSize: pageState.pageSize,
      })
    );
  }, [dispatch , pageState?.page , pageState?.pageSize]);

  return (
    <>
      <Helmet>
        <title> Real Opinion Admin | Singel Publisher User</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack spacing={2} direction={"row"} justifyContent={"space-between"}>
          <Typography variant="h6">Publisher Details</Typography>
        </Stack>

        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Min Data"
              value={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, startDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Max Data"
              value={date?.endDate}
              minDate={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, endDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          {date?.startDate && date?.endDate && (
            <Button variant="contained" onClick={dateWiseUser}>
              find data
            </Button>
          )}
        </Stack>

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={adminColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              // loading={loading ? <Loader /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>
      </Body>
    </>
  );
};

export default PublisherUserInfo;
